<template>
  <div class="modal-card field-select-model">
    <header class="modal-card-head">
      <p class="modal-card-title is-centered">命名匯出欄位</p>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <b-field label="選擇紀錄" horizontal>
          <b-select
            v-model="selectedConfigName"
            @input="selectConfig"
            placeholder="請選擇紀錄"
          >
            <option
              v-for="(option, index) in exportConfig"
              :value="option.name"
              :key="index"
            >
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <b-table :data="selectedFields" :narrowed="true" :hoverable="true">
        <b-table-column label="編號" width="60" numeric v-slot="props">
          {{ props.row.id }}
        </b-table-column>

        <b-table-column label="原始名稱" v-slot="props">
          {{ props.row.display_name }}
        </b-table-column>

        <b-table-column label="別名" v-slot="props">
          <b-input v-model="props.row.alias_name" />
        </b-table-column>
      </b-table>
    </section>

    <footer class="modal-card-foot">
      <div style="width: 100%">
        <div class="buttons is-right">
          <button class="button" type="button" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </button>
          <button
            class="button is-primary"
            :disabled="!canSave"
            @click.prevent="onSave"
          >
            儲存
          </button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'RenameFieldsModel',

  props: {
    activityId: {
      type: Number,
      default: 0
    },
    exportConfig: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedConfigName: null,
      selectedFields: []
    }
  },
  computed: {
    canSave() {
      return this.selectedConfigName && this.selectedFields.length > 0
    }
  },
  watch: {
    exportConfig(exportConfig) {
      const config =
        exportConfig &&
        exportConfig.find(c => c.name === this.selectedConfigName)

      if (config) {
        this.selectedFields = this.mergeConfigFields(config)
      } else {
        this.selectedFields = [...this.fields]
      }
    }
  },
  mounted() {
    const config = this.exportConfig && this.exportConfig[0]

    if (config) {
      this.selectedConfigName = config.name
      this.selectedFields = this.mergeConfigFields(config)
    } else {
      this.selectedConfigName = 'default'
      this.selectedFields = [...this.fields]
    }
  },
  methods: {
    mergeConfigFields(config) {
      let fields = []

      config.fields.forEach(f => {
        const field = this.fields.find(
          field =>
            f.class_type === field.class_type &&
            f.property_name === field.property_name
        )

        if (field) {
          fields.push({
            ...field,
            alias_name: f.alias_name
          })
        }
      })

      return fields
    },
    selectConfig(configName) {
      const config =
        this.exportConfig && this.exportConfig.find(c => c.name === configName)

      this.selectedFields = this.mergeConfigFields(config)
    },
    async onSave() {
      if (!this.canSave) {
        return
      }

      const fields = this.selectedFields.map(f => ({
        class_type: f.class_type,
        property_name: f.property_name,
        alias_name: f.alias_name
      }))

      let exportConfig = []
      const index = this.exportConfig.findIndex(
        c => c.name === this.selectedConfigName
      )

      if (index === -1) {
        exportConfig = [
          ...this.exportConfig,
          { name: this.selectedConfigName, fields }
        ]
      } else {
        exportConfig = [
          ...this.exportConfig.slice(0, index),
          { name: this.selectedConfigName, fields },
          ...this.exportConfig.slice(index + 1)
        ]
      }

      this.$emit('save-fields', exportConfig)
    }
  }
}
</script>

<style lang="scss">
.field-select-model {
  .field {
    height: 100%;

    .field-select {
      height: 100%;

      .select {
        width: 100%;
        height: 100%;

        select {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .margin-auto {
    margin: auto;
  }
}
</style>
